











import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
});
